export default function Card({ title, value, icon, bg, link }) {
    return (
        <div
            className={`bg-gradient-to-r ${bg} text-white rounded-lg sm:rounded-2xl p-3 sm:p-6 shadow-lg flex justify-between items-center w-full group`}
        >
            <div className="flex items-center justify-between w-full">
                <div>
                    <p className="text-[12px] sm:text-sm xl:text-base font-medium opacity-80">
                        {title}
                    </p>
                    <p className="text-[14px] sm:text-lg xl:text-3xl font-bold">
                        {value}
                    </p>
                </div>
                <div
                    className="w-6 h-6 md:w-8 md:h-8 xl:w-12 xl:h-12 opacity-80
                flex items-center justify-center
                [&_svg]:w-full [&_svg]:h-full
                group-hover:scale-125 transition-transform duration-300"
                >
                    {icon}
                </div>
            </div>
        </div>
    );
}